import {
  administrative,
  declareFieldMeanings,
  identity,
  means,
} from '../../../src/issues/field-meanings';

/** What each fire inspection detail means to an owner. */
export const fieldMeanings = declareFieldMeanings({
  sources: ['fire-inspections'],
  declarations: [
    identity(
      'inspection_number',
      'address',
      'block',
      'lot',
      'street_name',
      'street_number_low',
      'street_number_high',
      'street_suffix',
      'unit',
      'occupant_number',
    ),
    administrative(
      'latitude',
      'longitude',
      'data_as_of',
      'data_loaded_at',
      ':id',
      ':created_at',
      ':updated_at',
    ),
    means('detail', 'the inspection type', ['type', 'inspection_type']),
    means(
      'description',
      'how the fire department describes the inspection',
      ['description', 'inspection_type_description'],
      {
        matters: 'reworded what was inspected',
        means:
          "This is the fire department's description of the inspection. A change means it reworded what was inspected.",
      },
    ),
    means('status', 'the inspection status', ['status', 'inspection_status']),
    means('date', 'the inspection start date', ['startedAt', 'inspection_start_date']),
    means('date', 'the inspection end date', ['endedAt', 'inspection_end_date']),
  ],
});
